import { render } from "./ConsultingRoom.vue?vue&type=template&id=2e05156e"
import script from "./ConsultingRoom.vue?vue&type=script&lang=js"
export * from "./ConsultingRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__